import axiosInstance from "./api_helper";

const retourFournisseurService = {
  
  list: ({ fournisseurId, dateFrom, dateTo, query }) => {
    const params = {};
    if (fournisseurId !== undefined && fournisseurId !== null) params.fournisseurId = fournisseurId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (query) params.query = query;

    return axiosInstance.get(`/api/retours-fournisseur`, { params });
  },

  resume: (params) => {
    return axiosInstance.get(`/api/retours-fournisseur/resume`, { params });
  },

  search: (params) => {
    return axiosInstance.get(`/api/retours-fournisseur/search`, { params });
  },

  generateNumero: () => {
    return axiosInstance.get(`/api/retours-fournisseur/generate-number`);
  },

  getById: (id) => {
    return axiosInstance.get(`/api/retours-fournisseur/${id}`);
  },

  create: (data) => {
    return axiosInstance.post(`/api/retours-fournisseur`, data);
  },

  update: (id, data) => {
    return axiosInstance.put(`/api/retours-fournisseur/${id}`, data);
  },

  validate: (id) => {
    return axiosInstance.post(`/api/retours-fournisseur/${id}/validate`);
  },

  cancel: (id) => {
    return axiosInstance.post(`/api/retours-fournisseur/${id}/cancel`);
  },

  delete: (id) => {
    return axiosInstance.delete(`/api/retours-fournisseur/${id}`);
  },

  generatePdf: (id) => {
    return axiosInstance.get(`/api/retours-fournisseur/${id}/pdf`, {
      responseType: 'blob'
    });
  }
};

export default retourFournisseurService;
